export default "__VITE_ASSET__a2b24eda__"